import { render } from "./Service.vue?vue&type=template&id=3ac6fb11"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=3ac6fb11&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__